import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  es: {
    translation: {
      // Navbar
      nav: {
        gallery: 'Galería',
        demos: 'Demos',
        map3d: 'Mapa 3D',
        subscription: 'Suscripciones',
        reservations: 'Reservas',
        blog: 'Blog',
        contact: 'Contacto',
        login: 'Iniciar Sesión',
        dashboard: 'Mi Dashboard',
        admin: 'Panel Admin',
        logout: 'Cerrar Sesión'
      },
      // Landing hero
      landing: {
        heroSubtitle: 'Descubre las misteriosas Líneas de Nasca y Palpa en una experiencia inmersiva 360° que te transportará a través del tiempo',
        exploreBtn: 'Explorar Ahora',
        subscribeBtn: 'Suscribirse',
        featuresTitle: 'Una Experiencia Única',
        feature1Title: 'Explora en 360°',
        feature1Desc: 'Experimenta las Líneas de Nasca como nunca antes. Vuela sobre los geoglifos en una experiencia inmersiva de realidad virtual.',
        feature2Title: 'Contenido Exclusivo',
        feature2Desc: 'Accede a nuestra colección completa de videos 360°, incluyendo las Líneas de Palpa y nuestro museo virtual.',
        feature3Title: 'Cabina VR Física',
        feature3Desc: 'Reserva tu sesión en nuestra cabina VR para vivir la experiencia completa con visores Meta Quest.',
        showcaseBadge: 'Vitrina de Experiencias',
        showcaseTitle: 'Contenido',
        showcaseSubtitle: 'Explora todo el contenido disponible en nuestra plataforma, organizado por categoría.',
        showcaseEmpty: 'Contenido próximamente disponible',
        experiences: 'experiencias',
        experience: 'experiencia',
        subscribeCtaTitle: 'Suscríbete Ahora',
        subscribeCtaSubtitle: 'Obtén acceso ilimitado a todos los contenidos y experiencias 360°',
        subscribeCtaButton: 'Ver Planes',
        impactTitle: 'Impacto Ambiental Positivo',
        impactDesc: 'Al experimentar las Líneas de Nasca virtualmente, reduces el impacto ambiental del turismo físico, ayudando a preservar estos tesoros ancestrales para las futuras generaciones.'
      },
      // Gallery
      gallery: {
        title: 'Galería de Videos 360°',
        subtitle: 'Explora las Líneas de Nasca y Palpa en experiencias inmersivas',
        allLanguages: 'Todos los idiomas',
        needSubscription: 'Necesitas una suscripción activa para acceder a la Galería de Videos 360° de las Líneas de Nasca y Palpa.',
        viewPlans: 'Ver Planes de Suscripción'
      },
      // Demos (public preview videos)
      demos: {
        title: 'Videos Demo Gratuitos',
        subtitle: 'Previsualiza nuestro contenido inmersivo antes de suscribirte — completamente gratis',
        badge: 'Acceso Libre',
        noDemos: 'Aún no hay videos demo disponibles',
        wantMore: '¿Te gustó? Accede a todo nuestro catálogo premium',
        ctaSubscribe: 'Ver planes de suscripción'
      },
      // Categories
      categories: {
        all: 'Todos',
        nasca: 'Líneas de Nasca',
        palpa: 'Líneas de Palpa',
        museum: 'Museo Virtual',
        archaeological: 'Sitios Arqueológicos',
        nature: 'Atractivos Naturales',
        other: 'Otros'
      },
      // Languages
      languages: {
        es: 'Español',
        en: 'Inglés',
        ja: 'Japonés',
        pt: 'Portugués',
        zh: 'Chino',
        it: 'Italiano',
        other: 'Otros'
      },
      // Blog
      blog: {
        title: 'Blog de la Comunidad',
        subtitle: 'Descubre y comparte experiencias sobre las Líneas de Nazca',
        badge: 'Comunidad Nazca360',
        newPost: 'Nuevo Post',
        noPosts: 'No hay posts aún',
        firstToPublish: 'Sé el primero en publicar',
        back: 'Volver al Blog'
      },
      // Common
      common: {
        loading: 'Cargando...',
        save: 'Guardar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Eliminar',
        confirm: 'Confirmar'
      },
      // Subscription
      subscription: {
        premiumAccess: 'Acceso Premium',
        renewTitle: 'Renovar Suscripción',
        subscribeTitle: 'Suscríbete a Nazca360',
        renewSubtitle: 'Extiende tu acceso premium y sigue explorando las maravillas de Nazca',
        subscribeSubtitle: 'Elige tu plan y comienza tu experiencia inmersiva',
        selectPlan: 'Selecciona tu plan',
        step2SelectPlan: 'Paso 2: Selecciona tu plan',
        mostPopular: 'MÁS POPULAR',
        month: 'Mes',
        months: 'Meses',
        daysAccess: 'días de acceso',
        includedInAll: 'Incluido en todos los planes',
        orderSummary: 'Resumen de tu pedido',
        total: 'Total',
        payWithPaypal: 'Pagar con PayPal',
        processing: 'Procesando...',
        creatingAccount: 'Paso 1: Crea tu cuenta',
        step1Title: 'Paso 1: Crear Cuenta',
        fullName: 'Nombre Completo',
        yourName: 'Tu nombre',
        emailLabel: 'Email',
        yourEmail: 'tu@email.com',
        password: 'Contraseña',
        passwordPlaceholder: 'Mínimo 6 caracteres',
        confirmPassword: 'Confirmar Contraseña',
        repeatPassword: 'Repite tu contraseña',
        continueBtn: 'Continuar',
        alreadyHaveAccount: '¿Ya tienes cuenta?',
        signIn: 'Inicia Sesión',
        feat1: 'Acceso ilimitado a videos 360°',
        feat2: 'Contenido exclusivo de las Líneas de Nazca',
        feat3: 'Experiencia VR inmersiva',
        feat4: 'Streaming en alta calidad 4K',
        save: 'Ahorra'
      },
      // Contact
      contact: {
        badge: 'Estamos aquí para ti',
        title: 'Contáctanos',
        subtitle: 'Estamos listos para ayudarte a vivir la experiencia Nasca360',
        address: 'Dirección',
        phoneWa: 'Teléfono / WhatsApp',
        email: 'Email',
        hours: 'Horario de Atención',
        sendWa: 'Enviar WhatsApp',
        sendEmail: 'Enviar email',
        ourLocation: 'Nuestra Ubicación',
        locationDesc: 'Visítanos en el centro de Nasca, en el famoso Restobar Nazka.',
        sendMessage: 'Envíanos un Mensaje',
        formIntro: '¿Tienes preguntas o necesitas información? Escríbenos y te responderemos a la brevedad.',
        fullName: 'Nombre Completo',
        yourName: 'Tu nombre',
        yourEmail: 'tu@email.com',
        subject: 'Asunto',
        subjectPlaceholder: '¿En qué podemos ayudarte?',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos más...',
        sendBtn: 'Enviar Mensaje',
        sending: 'Enviando...',
        successMsg: 'Mensaje enviado. Te contactaremos pronto.',
        errorMsg: 'Error al enviar el mensaje. Por favor intenta de nuevo.'
      }
    }
  },
  en: {
    translation: {
      nav: {
        gallery: 'Gallery',
        demos: 'Demos',
        map3d: '3D Map',
        subscription: 'Subscriptions',
        reservations: 'Reservations',
        blog: 'Blog',
        contact: 'Contact',
        login: 'Sign In',
        dashboard: 'My Dashboard',
        admin: 'Admin Panel',
        logout: 'Sign Out'
      },
      landing: {
        heroSubtitle: 'Discover the mysterious Nasca and Palpa Lines in an immersive 360° experience that will take you back through time',
        exploreBtn: 'Explore Now',
        subscribeBtn: 'Subscribe',
        featuresTitle: 'A Unique Experience',
        feature1Title: 'Explore in 360°',
        feature1Desc: 'Experience the Nasca Lines like never before. Fly over the geoglyphs in an immersive virtual reality experience.',
        feature2Title: 'Exclusive Content',
        feature2Desc: 'Access our complete collection of 360° videos, including the Palpa Lines and our virtual museum.',
        feature3Title: 'Physical VR Booth',
        feature3Desc: 'Reserve your session in our VR booth to enjoy the full experience with Meta Quest headsets.',
        showcaseBadge: 'Experience Showcase',
        showcaseTitle: 'Content',
        showcaseSubtitle: 'Browse all the content available on our platform, organized by category.',
        showcaseEmpty: 'Content coming soon',
        experiences: 'experiences',
        experience: 'experience',
        subscribeCtaTitle: 'Subscribe Now',
        subscribeCtaSubtitle: 'Get unlimited access to all 360° content and experiences',
        subscribeCtaButton: 'View Plans',
        impactTitle: 'Positive Environmental Impact',
        impactDesc: 'By experiencing the Nasca Lines virtually, you reduce the environmental impact of physical tourism, helping preserve these ancient treasures for future generations.'
      },
      gallery: {
        title: '360° Video Gallery',
        subtitle: 'Explore the Nasca and Palpa Lines in immersive experiences',
        allLanguages: 'All languages',
        needSubscription: 'You need an active subscription to access the 360° Video Gallery of the Nasca and Palpa Lines.',
        viewPlans: 'View Subscription Plans'
      },
      demos: {
        title: 'Free Demo Videos',
        subtitle: 'Preview our immersive content before subscribing — completely free',
        badge: 'Free Access',
        noDemos: 'No demo videos available yet',
        wantMore: 'Liked it? Access our full premium catalog',
        ctaSubscribe: 'View subscription plans'
      },
      categories: {
        all: 'All',
        nasca: 'Nasca Lines',
        palpa: 'Palpa Lines',
        museum: 'Virtual Museum',
        archaeological: 'Archaeological Sites',
        nature: 'Natural Attractions',
        other: 'Others'
      },
      languages: {
        es: 'Spanish',
        en: 'English',
        ja: 'Japanese',
        pt: 'Portuguese',
        zh: 'Chinese',
        it: 'Italian',
        other: 'Others'
      },
      blog: {
        title: 'Community Blog',
        subtitle: 'Discover and share experiences about the Nazca Lines',
        badge: 'Nazca360 Community',
        newPost: 'New Post',
        noPosts: 'No posts yet',
        firstToPublish: 'Be the first to publish',
        back: 'Back to Blog'
      },
      common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        confirm: 'Confirm'
      },
      subscription: {
        premiumAccess: 'Premium Access',
        renewTitle: 'Renew Subscription',
        subscribeTitle: 'Subscribe to Nazca360',
        renewSubtitle: 'Extend your premium access and keep exploring the wonders of Nazca',
        subscribeSubtitle: 'Choose your plan and start your immersive experience',
        selectPlan: 'Select your plan',
        step2SelectPlan: 'Step 2: Select your plan',
        mostPopular: 'MOST POPULAR',
        month: 'Month',
        months: 'Months',
        daysAccess: 'days of access',
        includedInAll: 'Included in all plans',
        orderSummary: 'Order Summary',
        total: 'Total',
        payWithPaypal: 'Pay with PayPal',
        processing: 'Processing...',
        creatingAccount: 'Step 1: Create your account',
        step1Title: 'Step 1: Create Account',
        fullName: 'Full Name',
        yourName: 'Your name',
        emailLabel: 'Email',
        yourEmail: 'you@email.com',
        password: 'Password',
        passwordPlaceholder: 'At least 6 characters',
        confirmPassword: 'Confirm Password',
        repeatPassword: 'Repeat your password',
        continueBtn: 'Continue',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign In',
        feat1: 'Unlimited access to 360° videos',
        feat2: 'Exclusive Nazca Lines content',
        feat3: 'Immersive VR experience',
        feat4: '4K high-quality streaming',
        save: 'Save'
      },
      contact: {
        badge: 'We are here for you',
        title: 'Contact Us',
        subtitle: 'We are ready to help you experience Nasca360',
        address: 'Address',
        phoneWa: 'Phone / WhatsApp',
        email: 'Email',
        hours: 'Business Hours',
        sendWa: 'Send WhatsApp',
        sendEmail: 'Send email',
        ourLocation: 'Our Location',
        locationDesc: 'Visit us in downtown Nasca, at the famous Restobar Nazka.',
        sendMessage: 'Send us a Message',
        formIntro: 'Have questions or need information? Write to us and we\'ll get back to you shortly.',
        fullName: 'Full Name',
        yourName: 'Your name',
        yourEmail: 'you@email.com',
        subject: 'Subject',
        subjectPlaceholder: 'How can we help?',
        message: 'Message',
        messagePlaceholder: 'Tell us more...',
        sendBtn: 'Send Message',
        sending: 'Sending...',
        successMsg: 'Message sent. We\'ll contact you soon.',
        errorMsg: 'Error sending message. Please try again.'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',    // default: Spanish (used when no saved preference exists)
    supportedLngs: ['es', 'en'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],  // ONLY user's saved preference; browser lang is ignored
      lookupLocalStorage: 'nazca360_lang',
      caches: ['localStorage']
    }
  });

export default i18n;
